export const BEFORE_NAVIGATION_EVENT = "slant:before-navigation"

export class BeforeNavigationEvent extends Event {
  readonly href: string

  constructor(href: string) {
    super(BEFORE_NAVIGATION_EVENT, { cancelable: true })
    this.href = new URL(href, window.location.href).href
  }
}

export function requestNavigation(href: string) {
  return window.dispatchEvent(new BeforeNavigationEvent(href))
}

export function guardHistoryNavigation(canLeave: () => boolean) {
  const browserWindow: Window & { navigation?: { currentEntry: Pick<NavigationHistoryEntry, "index"> | null } } = window
  const navigation = browserWindow.navigation
  const originalIndex = navigation?.currentEntry?.index
  const originalUrl = window.location.href
  const originalState = window.history.state
  let restoring = false

  const onPopState = (event: PopStateEvent) => {
    if (restoring) {
      event.stopImmediatePropagation()
      restoring = false
      return
    }
    if (canLeave()) return

    event.stopImmediatePropagation()
    const destinationIndex = navigation?.currentEntry?.index
    if (originalIndex !== undefined && destinationIndex !== undefined) {
      if (originalIndex === destinationIndex) return
      restoring = true
      window.history.go(originalIndex - destinationIndex)
    } else {
      window.history.pushState(originalState, "", originalUrl)
    }
  }

  window.addEventListener("popstate", onPopState, true)
  return () => window.removeEventListener("popstate", onPopState, true)
}
